import { useCalculation } from "@/hooks/use-calculation";
import { DataTable } from "@msuite/ui/table";
import type { CalculationPanelBaseProps } from "../shared";
import { CalculationServicesSubrow } from "./calculation-services-subrow";
import { columns } from "./table-config";

export function CalculationServices({ calculationId }: CalculationPanelBaseProps) {
	/** Hooks */
	const { calculation, queryKey, isLoading, refetch } = useCalculation(calculationId);

	/** Render */
	return (
		<DataTable
			data={calculation?._serviceCalculationItems}
			columns={columns}
			persistenceKey="calculation-services-table"
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={null}
			getRowCanExpand={() => true}
			renderSubRows={(row) => <CalculationServicesSubrow row={row} />}
		/>
	);
}
